import { useState } from 'react';

import type { TLeasingOrderResponse } from '@/components/App/Leasing/types';
import { OfferCard } from '@/components/Shared/ui';

import { LeasingDetails } from '../../ui';

type TLeasingDeclinedItemProps = {
  leasingOffer: TLeasingOrderResponse;
};

const LeasingDeclinedItem = ({ leasingOffer }: TLeasingDeclinedItemProps) => {
  const [isLeasingDetailsModalOpen, setIsLeasingDetailsModalOpen] =
    useState(false);

  return (
    <>
      <OfferCard
        className="ie-leasing-item"
        status="error"
        statusText={leasingOffer.status.name}
      >
        <OfferCard.Header
          title={leasingOffer.leasingCompany.name}
          icon={leasingOffer.leasingCompany.icon}
          status="error"
          descriptionAction={
            leasingOffer.comment
              ? {
                  onClick: () => setIsLeasingDetailsModalOpen(true),
                  text: <span className="ie-offer-step__hidden">Описание</span>
                }
              : undefined
          }
        />
      </OfferCard>

      <LeasingDetails
        isModalOpen={isLeasingDetailsModalOpen}
        leasingOffer={leasingOffer}
        onClose={() => setIsLeasingDetailsModalOpen(false)}
      />
    </>
  );
};

export default LeasingDeclinedItem;
